// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__zYmoZ","buttons":"SendReceipts_buttons__2qbDV","email":"SendReceipts_email__1EVuA","bookApptTitle":"SendReceipts_bookApptTitle__2Jnp1"};